import { AuxiliaryEngineMakerBM } from '../../types/BusinessModel/Vessel/AuxiliaryEngineMakerBM';
import { AuxiliaryEngineMaker } from '../../types/ViewModel/Vessel/AuxiliaryEngineMaker';

export class AuxiliaryEngineMakerFactory {
    public create(data: AuxiliaryEngineMakerBM): AuxiliaryEngineMaker {
        return new AuxiliaryEngineMaker(data.id, data.name);
    }
}
